enum AppRoutes {
    create = '/create',
    edit = '/edit',
    sfdc = '/sfdc',
    sfdc_source = '/sfdc/source',
    sfdc_target = '/sfdc/target',
    sfdc_source_callback = '/sfdc/source/oauth2/callback',
    sfdc_target_callback = '/sfdc/target/oauth2/callback',
    customers = '/',
    configurations = '/configurations',
    externalHome = '/ext',
    storage = '/storage',
    user_management = '/usermanagement',
}

export default AppRoutes;
